import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onScrollToSteps: () => void;
}

export default function HeroSection({ onScrollToSteps }: HeroSectionProps) {
  return (
    <section className="relative pt-32 pb-20 px-4 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent dark:from-primary/10" />
      
      <div className="relative max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 dark:bg-primary/20 rounded-full mb-6">
          <Icon name="AcademicCapIcon" size={20} className="text-primary" />
          <span className="text-sm font-medium text-primary">Simple. Powerful. Proven.</span>
        </div>
        
        <h1 className="text-4xl lg:text-5xl font-heading font-bold bg-gradient-to-r from-primary via-primary to-secondary bg-clip-text text-transparent mb-6">
          How Signaly Transforms Trading
        </h1>
        
        <p className="text-lg lg:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Discover how our AI-driven platform analyzes markets 24/7 and delivers actionable signals directly to your device—no complex charts, no endless training required.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onScrollToSteps}
            className="px-8 py-3 bg-primary text-primary-foreground font-heading font-semibold rounded-md hover:scale-105 hover:shadow-cyan-glow dark:hover:shadow-cyan-glow transition-all duration-200 flex items-center space-x-2"
          >
            <span>See How It Works</span>
            <Icon name="ArrowDownIcon" size={20} />
          </button>
          
          <a
            href="/app-download"
            className="px-8 py-3 bg-card border border-border text-foreground font-heading font-semibold rounded-md hover:bg-muted transition-all duration-200"
          >
            Download App
          </a>
        </div>
        
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <div className="flex flex-col items-center space-y-2">
            <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name="CheckCircleIcon" size={24} className="text-success" />
            </div>
            <p className="text-sm font-medium text-foreground">87% Confidence Rate</p>
          </div>
          
          <div className="flex flex-col items-center space-y-2">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="UserGroupIcon" size={24} className="text-primary" />
            </div>
            <p className="text-sm font-medium text-foreground">50,000+ Active Traders</p>
          </div>
          
          <div className="flex flex-col items-center space-y-2">
            <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
              <Icon name="ClockIcon" size={24} className="text-secondary" />
            </div>
            <p className="text-sm font-medium text-foreground">24/7 Market Analysis</p>
          </div>
        </div>
      </div>
    </section>
  );
}